import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
import { Card, Stack, Link, Container, Typography } from "@mui/material";
// layouts
import AuthLayout from "../layouts/AuthLayout";
// components
import Page from "../components/Page";
import { MHidden } from "../components/@material-extend";
import { LoginForm } from "../components/authentication/login";
import AuthSocial from "../components/authentication/AuthSocial";

// ----------------------------------------------------------------------
import { useDispatch, useSelector } from "react-redux";

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex"
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: "100%",
  maxWidth: 464,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------
const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";
const ROLE_POSTDOC = "post_doc";

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { role, isLoggedIn } = useSelector((state) => state.authReducer);
  const { message } = useSelector((state) => state.messageReducer);

  useEffect(() => {
    if (isLoggedIn) {
      switch (role) {
        case ROLE_ADMIN:
          return navigate("/profile/admin", { replace: true });
        case ROLE_MENTOR:
          return navigate("/profile/mentor", { replace: true });
        case ROLE_POSTDOC:
          return navigate("/profile/post_doc", { replace: true });
        case ROLE_PHD_3Y:
          return navigate("/profile/phd_3y", { replace: true });
        case ROLE_PHD_5Y:
          return navigate("/profile/phd_5y", { replace: true });
        default:
          return;
      }
    }
  }, []);

  return (
    <RootStyle title="Login">
      <AuthLayout>
        Don’t have an account? &nbsp;
        <Link
          underline="none"
          variant="subtitle2"
          component={RouterLink}
          to="/register"
        >
          Get started
        </Link>
      </AuthLayout>

      <MHidden width="mdDown">
        <SectionStyle>
          {/* <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}></Typography> */}
          {/* <img src="/member/static/logo.jpg" alt="c2f" /> */}
        </SectionStyle>
      </MHidden>

      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 5 }}>
            <Typography variant="h4" gutterBottom>
              Sign in to C2F
            </Typography>
            <Typography sx={{ color: "text.secondary" }}>
              Enter your details below.
            </Typography>
          </Stack>

          <LoginForm />

          <MHidden width="smUp">
            <Typography variant="body2" align="center" sx={{ mt: 3 }}>
              Don’t have an account?&nbsp;
              <Link variant="subtitle2" component={RouterLink} to="register">
                Get started
              </Link>
            </Typography>
          </MHidden>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
